














import { Component, Prop, Provide, Vue } from 'vue-property-decorator'

@Component
export default class CmsHeader extends Vue {
  private getType() {
    if (this.$route.path == '/docpreview') {
      return 2
    } else if (this.$route.path == '/cms') {
      return 3
    } else if (this.$route.path == '/docupload') {
      return 1
    }
  }
}
